export var EducationLevel;

(function (EducationLevel) {
  EducationLevel["Illiterate"] = "illiterate";
  EducationLevel["PrimarySchoolBelow"] = "primarySchoolBelow";
  EducationLevel["JuniorHighSchool"] = "juniorHighSchool";
  EducationLevel["HighSchool"] = "highSchool";
  EducationLevel["CollegeOrUniversity"] = "collegeOrUniversity";
  EducationLevel["GraduateSchoolOrAbove"] = "graduateSchoolOrAbove";
})(EducationLevel || (EducationLevel = {}));

export var Occupations;

(function (Occupations) {
  Occupations["Military"] = "military";
  Occupations["Government"] = "government";
  Occupations["Education"] = "education";
  Occupations["Industry"] = "industry";
  Occupations["Business"] = "business";
  Occupations["Freelancer"] = "freelancer";
  Occupations["Household"] = "household";
  Occupations["Others"] = "others";
})(Occupations || (Occupations = {}));

export var InsuranceCompany;

(function (InsuranceCompany) {
  InsuranceCompany["TaiwanBankLife"] = "taiwanBankLife";
  InsuranceCompany["TaiwanLife"] = "taiwanLife";
  InsuranceCompany["PrudentialLife"] = "prudentialLife";
  InsuranceCompany["CathayLife"] = "cathayLife";
  InsuranceCompany["ChinaLife"] = "chinaLife";
  InsuranceCompany["NanshanLife"] = "nanshanLife";
  InsuranceCompany["ShinKongLife"] = "shinKongLife";
  InsuranceCompany["FubonLife"] = "fubonLife";
  InsuranceCompany["KuoBaoLife"] = "kuoBaoLife";
  InsuranceCompany["SinoPacLife"] = "sinoPacLife";
  InsuranceCompany["ChaoYangLife"] = "chaoYangLife";
  InsuranceCompany["HappinessLife"] = "happinessLife";
  InsuranceCompany["FarGloryLife"] = "farGloryLife";
  InsuranceCompany["HontaiLife"] = "hontaiLife";
  InsuranceCompany["AllianzLife"] = "allianzLife";
  InsuranceCompany["PostOfficeLife"] = "postOfficeLife";
  InsuranceCompany["PrudentialIntLife"] = "prudentialIntLife";
  InsuranceCompany["GlobalLife"] = "globalLife";
  InsuranceCompany["YuanDaLife"] = "yuanDaLife";
  InsuranceCompany["CTBCLife"] = "ctbcLife";
  InsuranceCompany["FirstGoldLife"] = "firstGoldLife";
  InsuranceCompany["TCBLife"] = "tcbLife";
  InsuranceCompany["InternationalHealthLife"] = "internationalHealthLife";
  InsuranceCompany["AIALife"] = "aiaLife";
  InsuranceCompany["BNPPLife"] = "bnppLife";
  InsuranceCompany["ChungTaiLife"] = "chungTaiLife";
  InsuranceCompany["ZurichLife"] = "zurichLife";
})(InsuranceCompany || (InsuranceCompany = {}));

export var DietaryPattern;

(function (DietaryPattern) {
  DietaryPattern["EggAndDairyVegetarian"] = "eggAndDairyVegetarian";
  DietaryPattern["EggVegetarian"] = "eggVegetarian";
  DietaryPattern["DairyVegetarian"] = "dairyVegetarian";
  DietaryPattern["Pescatarian"] = "pescatarian";
  DietaryPattern["Vegan"] = "vegan";
  DietaryPattern["FiveSpicesVegan"] = "fiveSpicesVegan";
})(DietaryPattern || (DietaryPattern = {}));

export var AllergenIntolerance;

(function (AllergenIntolerance) {
  AllergenIntolerance["FavaBean"] = "favaBean";
  AllergenIntolerance["Egg"] = "egg";
  AllergenIntolerance["MilkLactoseIntolerance"] = "milkLactoseIntolerance";
  AllergenIntolerance["Seafood"] = "seafood";
  AllergenIntolerance["Gluten"] = "gluten";
  AllergenIntolerance["Peanut"] = "peanut";
  AllergenIntolerance["Soy"] = "soy";
})(AllergenIntolerance || (AllergenIntolerance = {}));

export var Habit;

(function (Habit) {
  Habit["Smoking"] = "smoking";
  Habit["Drinking"] = "drinking";
  Habit["Areaca"] = "areaca";
})(Habit || (Habit = {}));

export var Diseases;

(function (Diseases) {
  Diseases["Hypertension"] = "hypertension";
  Diseases["Hyperlipidemia"] = "hyperlipidemia";
  Diseases["MetabolicSyndrome"] = "metabolicSyndrome";
  Diseases["FattyLiver"] = "fattyLiver";
  Diseases["Diabetes"] = "diabetes";
  Diseases["HeartDisease"] = "heartDisease";
  Diseases["Gout"] = "gout";
  Diseases["CKD"] = "ckd";
  Diseases["PeritonealDialysis"] = "peritonealDialysis";
  Diseases["UterineFibroids"] = "uterineFibroids";
  Diseases["Gallstones"] = "gallstones";
  Diseases["Others"] = "others";
})(Diseases || (Diseases = {}));

export var PregnancyStage;

(function (PregnancyStage) {
  PregnancyStage["FirstTrimester"] = "pregnancyFirstTrimester";
  PregnancyStage["SecondTrimester"] = "pregnancySecondTrimester";
  PregnancyStage["ThirdTrimester"] = "pregnancyThirdTrimester";
  PregnancyStage["LactationPeriod"] = "lactationPeriod";
})(PregnancyStage || (PregnancyStage = {}));

export var FamilyMember;

(function (FamilyMember) {
  FamilyMember["Father"] = "father";
  FamilyMember["Mother"] = "mother";
  FamilyMember["Son"] = "son";
  FamilyMember["Daughter"] = "daughter";
  FamilyMember["OlderBrother"] = "olderBrother";
  FamilyMember["YoungerBrother"] = "youngerBrother";
  FamilyMember["OlderSister"] = "olderSister";
  FamilyMember["YoungerSister"] = "youngerSister";
  FamilyMember["Uncle"] = "uncle";
  FamilyMember["Aunt"] = "aunt";
  FamilyMember["MaternalUncle"] = "maternalUncle";
  FamilyMember["MaternalAunt"] = "maternalAunt";
  FamilyMember["PaternalGrandfather"] = "paternalGrandfather";
  FamilyMember["PaternalGrandmother"] = "paternalGrandmother";
  FamilyMember["MaternalGrandfather"] = "maternalGrandfather";
  FamilyMember["MaternalGrandmother"] = "maternalGrandmother";
  FamilyMember["GreatPaternalGrandfather"] = "greatPaternalGrandfather";
  FamilyMember["GreatPaternalGrandmother"] = "greatPaternalGrandmother";
  FamilyMember["GreatMaternalGrandfather"] = "greatMaternalGrandfather";
  FamilyMember["GreatMaternalGrandmother"] = "greatMaternalGrandmother";
})(FamilyMember || (FamilyMember = {}));